import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import ArticleList from "../components/ArticleList"

/*
import Sidebar from '../components/Sidebar';
import Feed from '../components/Feed';
import Page from '../components/Page';
import Pagination from '../components/Pagination';
import { useSiteMetadata } from '../hooks';
({ data, pageContext })
*/

const CategoryTemplate = ({ data }) => {
  const { edges } = data.allMarkdownRemark;
  /*
  const { title: siteTitle, subtitle: siteSubtitle } = useSiteMetadata();

  const {
    category,
    currentPage,
    prevPagePath,
    nextPagePath,
    hasPrevPage,
    hasNextPage,
  } = pageContext;

  
  const pageTitle = currentPage > 0 ? `${category} - Page ${currentPage} - ${siteTitle}` : `${category} - ${siteTitle}`;
*/
  return (
    <Layout>
      <section>
        <ArticleList edges={edges} />
      </section>
    </Layout>
  );
};

export const query = graphql`
  query CategoryPage($category: String, $postsLimit: Int!, $postsOffset: Int!) {
    allMarkdownRemark(
        limit: $postsLimit,
        skip: $postsOffset,
        filter: { frontmatter: { category: { eq: $category }, template: { eq: "article" } } },
        sort: { order: DESC, fields: [frontmatter___date] }
      ){
      edges {
        node {
          id
          fields {
            categorySlug
            slug
          }
          frontmatter {
            title
            author
            date(formatString: "MMMM YYYY")
            category
            hero_image {
              childImageSharp {
                fluid( maxWidth: 800 ) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          excerpt(pruneLength: 200)
        }
      }
    }
  }
`;

export default CategoryTemplate;